import { UserAccountStatus, UserRole } from '../enums';

export function buildUserBanUpdate() {
  return {
    role: UserRole.CONSUMER,
    accountStatus: UserAccountStatus.BANNED,
  };
}

export function buildUserUnbanUpdate() {
  return {
    accountStatus: UserAccountStatus.ACTIVE,
  };
}

export function buildCreatorDisableUpdate() {
  return { disabled: true };
}

export function buildCreatorEnableUpdate() {
  return { disabled: false };
}
